/** 标题设置 */
import { Enum } from '@lighthouse/tools'

export interface TitleConfig {
    /** 是否显示标题，默认为1，显示 */
    showTitle: boolean
}

export const BlockType = Enum(
    'chart',
    'field',
    'image',
    'view',
    'button',
    'card',
    'divider',
    'fieldGroup',
    'video',
    'audio',
    'breadcrumb',
    'iframe',
    'collapse',
    'file',
    'container',
    'formContainer',
    'tabs',
    'text',
    'filter',
    'qrBarcode',
    'subForm',
    'icon',
    'subForm',
    'icon',
    'userCenter',
    'floatBox',
    'onOff',
    'toc'
)

export type BlockType = Enum<typeof BlockType>

export interface HttpResp<T = undefined> {
    success: boolean
    msg: string
    code: string
    content: T
}
